import { Suspense, useEffect, useState, Fragment, onEffect } from 'react';
import { Button, IconButton, Tag } from '@teo/components';
import {
  RotateLeft,
  RotateRight,
  Fullscreen,
  Expand,
  Cross,
  CrossFilled,
  Document,
} from '@teo/components/icons';

/** TODO: Enlarge icon doesn't look quite right there */

export const MagnifyImage = (props) => {
  const [maginify, setMagnify] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const [rotate, setRotate] = useState(0);

  useEffect(() => {
    if (!maginify) {
      setFullscreen(false);
    }
  });

  const fullScreenStyleBlock = {
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
    zIndex: 11,
    position: 'fixed',
    minHeight: '100vh',
    minWidth: '100vw',
    display: 'flex',
    padding: '25px',
  };

  const fullScreenStyleImg = {
    margin: 'auto',
    minHeight: '80vh',
    minWidth: '80vw',
    objectFit: 'contain',
  };

  const handleMouseDown = () => {
    props?.setHoverImage && props?.setHoverImage(true);
    setIsMouseDown(true);
  };

  const handleMouseUp = () => {
    props?.setHoverImage && props?.setHoverImage(false);
    setIsMouseDown(false);
  };

  const normalized = ((rotate % 360) + 360) % 360;
  const isVertical = normalized === 90 || normalized === 270;

  return (
    <>
      <div
        className="relative z-[2] overflow-hidden rounded"
        onClick={(ev) => {
          if (maginify) {
            ev.preventDefault();
            setMagnify(false);
          } else if (!props.showIcon) {
            setMagnify(!maginify);
          }
        }}
        onMouseEnter={handleMouseDown}
        onMouseLeave={handleMouseUp}
      >
        <img
          onLoad={props.onload}
          {...props}
          className={'nowrap ' + props.className}
        />
        {props.showIcon && (
          <div
            className={`absolute right-0 top-0 flex h-full w-full cursor-pointer bg-black/10 ${
              isMouseDown ? 'opacity-100' : 'opacity-0'
            }`}
            onClick={(ev) => {
              setMagnify(!maginify);
            }}
          >
            <Expand className="m-auto w-4 text-grey-05" />
          </div>
        )}
        {/*<Expand className="p-1 h-6 w-6 absolute right-0 top-0 bg-white" style={{border: '1px solid rgba(0,0,0,.1)', borderRaduis: '4px'}} />*/}
      </div>
      {maginify && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000cc]"
          onClick={() => setMagnify(false)}
        >
          {/* Image container */}
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000cc]"
            onClick={() => setMagnify(false)}
          >
            <div
              className={`pointer-events-none flex items-center justify-center ${
                fullscreen ? 'h-screen w-screen' : 'h-full w-full'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={props?.src ? props?.src : URL.createObjectURL(props?.src)}
                className={`pointer-events-auto transition-transform duration-300 ${
                  fullscreen ? 'h-full w-full object-contain' : 'h-auto w-auto'
                }`}
                style={{
                  transform: `rotate(${rotate}deg)`,
                }}
              />
            </div>
          </div>

          {/* Floating Controls (always on top) */}
          <div
            className="fixed top-4 right-4 z-[9999] flex gap-2 rounded bg-[#00000088] p-2"
            onClick={(ev) => ev.stopPropagation()}
          >
            <IconButton
              Icon={Expand}
              className="pointer-events-auto fill-white"
              variant="ghost"
              size="md"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                setFullscreen(!fullscreen);
              }}
            />
            <IconButton
              Icon={RotateLeft}
              className="pointer-events-auto fill-white"
              variant="ghost"
              size="md"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                setRotate((r) => r - 90);
              }}
            />
            <IconButton
              Icon={RotateRight}
              className="pointer-events-auto fill-white"
              variant="ghost"
              size="md"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                setRotate((r) => r + 90);
              }}
            />
            <IconButton
              Icon={() => <div className="text-2xl">X</div>}
              className="pointer-events-auto text-white"
              variant="ghost"
              size="md"
              onClick={(ev) => {
                setFullscreen(false);
                ev.preventDefault();
                ev.stopPropagation();
                setMagnify(false);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
